import React from "react"
import BasePage from "../components/BasePage"

export default function IndexPage() {
  return (
    <BasePage>
    </BasePage>
  )
}